import { userConstants } from '../constants/login.constants';

export function users(state = {}, action) {
    
    switch (action.type) {
        case userConstants.LOGIN_REQUEST:
            return {
                loading: true
            };
        case userConstants.LOGIN_SUCCESS:
            return {
                items: action.user
            };
        case userConstants.LOGIN_FAILURE:
            return {
                error: action.error
            };
        case userConstants.LOGOUT:
            return {};
        default:
            return state
    }
}